(function($) {$(document).ready(function() {

	$('.popout-links__m-link, .popout-links__close').on('click', event => {
		if (window.innerWidth >= 1200) return;

		$(event.target)
			.closest('.popout-links')
			.toggleClass('open');
	});

});;jQueryBridget("flickity", Flickity, $);})(window.NEW_jquery);